import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-gh",
  "use": "icon-icon-gh-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-gh\">\n  <path fill=\"#006b3f\" d=\"M0 0h512v512H0z\" />\n  <path fill=\"#fcd116\" d=\"M0 0h512v341.3H0z\" />\n  <path fill=\"#ce1126\" d=\"M0 0h512v170.7H0z\" />\n  <path d=\"m256 170.7 55.5 170.6L166.3 236h179.4L200.6 341.3z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol